exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".store-component{padding-bottom:49px}.store-component .slide-warp{position:relative}.store-component .slide-warp .slide{height:200px;width:100%;padding:10px 15px;object-fit:cover}@media only screen and (min-width:600px){.store-component .slide-warp .slide{height:300px}}.store-component .slide-warp .slide-title{position:absolute;bottom:10px;left:15px;right:15px;color:#fff;background:#000;opacity:.6;font-weight:600;padding:10px 15px}.store-component .rank-menu{margin:0 10px;height:30px;border-bottom:.5px solid #eee}.store-component .rank-menu .rank-item{padding:0 5px;color:#999;height:30px;outline:none}.store-component .rank-menu .teams{font-size:10px;background:green;color:#fff;border-radius:3px;margin-left:6px;height:18px;display:inline-block}.store-component .rank-menu .active{color:#333;font-weight:500}.store-component .slider-wrap{margin-top:44px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/develop/Store.scss
// module id = 616
// module chunks = 0